import { extendTheme } from '@chakra-ui/react'; // import theme from '@chakra-ui/theme';

export var customConstants = {
  headerHeight: {
    base: '80px',
    lg: '100px'
  },
  sectionsGap: {
    base: 24,
    xl: 32
  }
};
var themedButton = {
  baseStyle: {
    _hover: {
      transform: 'translateY(2px)'
    },
    borderRadius: 0,
    cursor: 'pointer',
    fontWeight: '400',
    maxHeight: 16,
    maxWidth: '25ch',
    px: 6,
    py: 3,
    textTransform: 'uppercase',
    transition: 'transform 0.2s',
    whiteSpace: 'normal !important'
  },
  defaultProps: {
    colorScheme: 'primary'
  },
  sizes: {
    md: {
      height: 'auto',
      minHeight: 8
    }
  },
  variants: {
    outline: {
      bg: 'none',
      border: '1px solid',
      borderColor: 'primary.500',
      color: 'secondary.500',
      textTransform: 'none'
    },
    solid: {
      _active: {
        bg: 'primary.700'
      },
      _hover: {
        bg: 'primary.600',
        color: 'secondary.500'
      },
      bg: 'primary.500',
      color: 'black'
    }
  }
};
var themedLink = {
  baseStyle: {
    _hover: {
      cursor: 'pointer',
      textDecoration: 'none'
    }
  },
  variants: {
    burgerMenuItem: {
      color: 'white',
      fontSize: 18,
      fontWeight: 300,
      textTransform: 'uppercase'
    },
    burgerSubmenuItem: {
      fontSize: 18
    },
    externalLink: {
      _hover: {
        color: 'primary.700'
      },
      borderBottom: '1px dotted',
      color: 'secondary.500'
    },
    submenuItem: {
      display: 'block',
      textTransform: 'initial'
    },
    topNavigationLink: {
      _focus: {
        boxShadow: '0 0 0 3px rgba(66,153,225,0.5)'
      },
      fontSize: [18, 18, 18, 20, 20, 25],
      textTransform: 'uppercase'
    }
  }
};
var themedSelect = {
  variants: {
    outline: {
      field: {
        bg: 'transparent',
        borderColor: 'primary.500',
        borderRadius: 0,
        borderStyle: 'solid',
        borderWidth: '1px',
        color: 'white',
        fontSize: 20,
        '& > option': {
          color: 'text'
        }
      },
      icon: {
        '& svg': {
          height: '3rem !important',
          width: '3rem !important'
        },
        color: 'primary.500',
        width: '3rem !important'
      }
    },
    solid: {
      field: {
        bg: 'primary.100',
        borderColor: 'primary.500',
        borderRadius: 0,
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    }
  }
};
var themedInput = {
  baseStyle: {
    field: {
      borderRadius: 0,
      borderStyle: 'solid',
      borderWidth: '1px'
    }
  },
  sizes: {
    md: {
      field: {
        borderRadius: '0',
        fontSize: 20
      }
    }
  },
  variants: {
    outline: {
      field: {
        bg: 'transparent',
        borderColor: 'primary.500',
        color: 'white'
      }
    },
    solid: {
      field: {
        bg: 'primary.100',
        borderColor: 'primary.500',
        color: 'secondary.500'
      }
    }
  }
};
var themedTextarea = {
  baseStyle: {
    borderRadius: 0,
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  sizes: {
    md: {
      borderRadius: 0,
      fontSize: 20
    }
  },
  variants: {
    outline: {
      bg: 'transparent',
      borderColor: 'primary.500',
      borderRadius: 0,
      borderStyle: 'solid',
      borderWidth: '1px',
      color: 'white',
      fontSize: 20
    },
    solid: {
      bg: 'primary.100',
      borderColor: 'primary.500',
      color: 'secondary.500'
    }
  }
};
var themedFormLabel = {
  baseStyle: {
    color: 'secondary.500',
    fontWeight: '400'
  }
};
var themedCheckbox = {
  baseStyle: {
    control: {
      borderColor: 'primary.500',
      borderStyle: 'solid',
      borderWidth: 1
    },
    label: {
      color: 'secondary.500',
      fontWeight: '400'
    }
  }
};
var themedRadio = {
  baseStyle: {
    control: {
      _checked: {
        _before: {
          bg: 'currentColor',
          borderRadius: '50%',
          content: '""',
          display: 'inline-block',
          height: '50%',
          position: 'relative',
          width: '50%'
        },
        _disabled: {
          bg: 'gray.200',
          borderColor: 'gray.200',
          color: 'gray.500'
        },
        _hover: {
          bg: 'blue.600',
          borderColor: 'blue.600'
        },
        bg: 'blue.500',
        borderColor: 'blue.500',
        color: 'white'
      },
      _disabled: {
        bg: 'gray.100',
        borderColor: 'gray.100'
      },
      _focus: {
        boxShadow: 'outline'
      },
      _indeterminate: {
        bg: 'blue.500',
        borderColor: 'blue.500',
        color: 'white'
      },
      _invalid: {
        borderColor: 'red.500'
      },
      border: '2px solid',
      borderColor: 'primary.500',
      borderRadius: 'full',
      color: 'white',
      h: 4,
      transition: 'box-shadow 250ms',
      w: 4
    },
    label: {
      _disabled: {
        opacity: 0.4
      },
      color: 'secondary.500',
      fontSize: 'md',
      userSelect: 'none'
    }
  }
};
var themedNumberInput = themedInput;
var customTheme = extendTheme({
  breakpoints: ['30em', '48em', '62em', '80em', '120em'],
  colors: {
    background: '#fff',
    dark: '#004E9B',
    light: '#fff',
    primary: {
      100: '#FFFCED',
      500: '#FFDD45',
      600: '#EFD627',
      700: '#E6C73E'
    },
    secondary: {
      500: '#004E9B'
    },
    text: '#004E9B'
  },
  components: {
    Button: themedButton,
    Checkbox: themedCheckbox,
    FormLabel: themedFormLabel,
    Input: themedInput,
    Link: themedLink,
    NumberInput: themedNumberInput,
    Radio: themedRadio,
    Select: themedSelect,
    Textarea: themedTextarea
  },
  customConstants: customConstants,
  fonts: {
    body: 'Futura PT, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    button: 'Futura PT, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    heading: 'Futura PT, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'Futura PT, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  },
  textStyles: {
    prose: {
      h1: {
        color: 'primary.500',
        fontSize: ['1.75rem', '1.75rem', '2.5rem', '2.5rem', '2.5rem', '3rem'],
        fontWeight: '900',
        mb: '0.888em',
        mt: 0,
        textTransform: 'uppercase'
      },
      h2: {
        color: 'secondary.500',
        fontSize: ['1.75rem', '1.75rem', '2.5rem'],
        fontWeight: '300',
        mb: '0.6em',
        mt: '1.8em'
      },
      h3: {
        color: 'secondary.500',
        fontSize: ['1.75rem', '1.75rem', '2.25rem'],
        fontWeight: '300',
        lineHeight: 1.1,
        mb: '0.6em',
        mt: '1em'
      },
      h4: {
        color: 'secondary.500',
        fontSize: '1.125rem',
        fontWeight: '300',
        mb: '0.5em',
        mt: '1.5em',
        textTransform: 'uppercase'
      },
      h5: {
        color: 'secondary.500',
        fontSize: '1rem',
        fontWeight: '300',
        mb: '1.25em',
        mt: '1.2em',
        textTransform: 'uppercase'
      },
      h6: {
        color: 'secondary.500',
        fontSize: '1rem',
        fontWeight: '300',
        mb: '1.25em',
        mt: '1.2em',
        textTransform: 'uppercase'
      },
      p: {
        color: 'secondary.500',
        fontSize: '1.125rem',
        fontWeight: '300',
        maxWidth: '100%',
        mb: '1.25em',
        mt: '1.2em'
      }
    },
    ui: {
      h1: {
        color: 'primary.500',
        fontSize: ['1.75rem', '1.75rem', '2.5rem', '2.5rem', '2.5rem', '3rem'],
        fontWeight: '900',
        maxWidth: '35ch',
        textTransform: 'uppercase'
      },
      h2: {
        color: 'secondary.500',
        fontSize: ['1.75rem', '1.75rem', '2.5rem'],
        fontWeight: '300',
        maxWidth: '35ch',
        textTransform: 'uppercase'
      },
      h3: {
        color: 'secondary.500',
        fontSize: ['1.25rem', '1.25rem', '1.5rem'],
        fontWeight: '300',
        maxWidth: '35ch',
        textTransform: 'uppercase'
      },
      h4: {
        color: 'secondary.500',
        fontSize: '1.125rem',
        fontWeight: '300',
        maxWidth: '35ch',
        textTransform: 'uppercase'
      },
      h5: {
        color: 'secondary.500',
        fontSize: '1rem',
        fontWeight: '300',
        textTransform: 'uppercase'
      },
      h6: {
        color: 'secondary.500',
        fontSize: '1rem',
        fontWeight: '300',
        textTransform: 'uppercase'
      },
      p: {
        color: 'secondary.500',
        fontSize: '1.125rem',
        fontWeight: '300',
        maxWidth: '70ch'
      }
    }
  }
});
customTheme.breakpoints.sm = '30em';
customTheme.breakpoints.md = '48em';
customTheme.breakpoints.lg = '62em';
customTheme.breakpoints.xl = '80em';
customTheme.breakpoints.xxl = '120em';
export default customTheme;